import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { PersonLink } from '../../types/person.js';

const LINK_TYPE_LABELS: Record<string, string> = {
  project: 'Projekt',
  todo: 'To-Do',
  reflection: 'Reflexion',
};

const LINK_TYPE_ICONS: Record<string, string> = {
  project: '📁',
  todo: '✅',
  reflection: '💭',
};

@customElement('cp-person-links')
export class CpPersonLinks extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) links: PersonLink[] = [];

  render() {
    if (this.links.length === 0) return nothing;

    return html`
      <div class="cp-person-links">
        <h3 class="cp-person-links__title">Verknüpfungen</h3>
        <div class="cp-person-links__list">
          ${this.links.map(link => html`
            <div class="cp-person-link">
              <span class="cp-person-link__icon">${LINK_TYPE_ICONS[link.link_type] ?? '🔗'}</span>
              <span class="cp-person-link__type">${LINK_TYPE_LABELS[link.link_type] ?? link.link_type}</span>
              <span class="cp-person-link__id">#${link.target_id}</span>
              ${link.description ? html`
                <span class="cp-person-link__desc">${link.description}</span>
              ` : nothing}
            </div>
          `)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-person-links': CpPersonLinks;
  }
}
